export * as Api from './api';
export var UserType;
(function (UserType) {
    UserType[UserType["Organisation"] = 0] = "Organisation";
    UserType[UserType["Adviser"] = 1] = "Adviser";
    UserType[UserType["Investor"] = 2] = "Investor";
})(UserType || (UserType = {}));
//# sourceMappingURL=index.js.map